// import { useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
// import { useEffect, useState } from "react";

// import "swiper/css";

// const TopBrands = ({ brands = [] }) => {
//   const navigate = useNavigate();
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth < 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   const handleClick = (brand) => {
//     navigate(`/product-category?brand=${brand.name}`);
//   };

//   if (!brands?.length) return null;

//   return (
//     <div className="max-w-7xl mx-auto px-4 mt-12">

//       <div className="bg-gradient-to-br from-white to-gray-50 p-6 md:p-8 rounded-md shadow-lg border">

//         {/* HEADER */}
//         <div className="flex justify-between items-center mb-8">
//           <h2 className="text-2xl md:text-3xl font-bold tracking-tight">
//             Top Brands
//           </h2>
//         </div>

//         {/* 📱 MOBILE SLIDER */}
//         {isMobile ? (
//           <Swiper
//             modules={[Autoplay]}
//             autoplay={{ delay: 2000 }}
//             loop
//             spaceBetween={14}
//             slidesPerView={2.3}
//           >
//             {brands.map((brand, i) => (
//               <SwiperSlide key={i}>
//                 <motion.div
//                   whileTap={{ scale: 0.92 }}
//                   whileHover={{ scale: 1.05 }}
//                   onClick={() => handleClick(brand)}
//                   className="bg-white p-6 rounded-2xl flex flex-col items-center justify-center shadow-md cursor-pointer"
//                 >
//                   <img
//                     src={brand.img}
//                     alt={brand.name}
//                     className="h-16 object-contain"
//                   />

//                   {/* 🔥 NAME */}
//                   <p className="mt-3 text-sm font-medium text-gray-700">
//                     {brand.name}
//                   </p>
//                 </motion.div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         ) : (

//           /* 💻 DESKTOP GRID */
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-8">

//             {brands.map((brand, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, scale: 0.85 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 transition={{ delay: i * 0.05 }}
//                 whileHover={{
//                   y: -10,
//                   scale: 1.06,
//                   boxShadow: "0px 15px 40px rgba(0,0,0,0.15)"
//                 }}
//                 whileTap={{ scale: 0.95 }}
//                 onClick={() => handleClick(brand)}
//                 className="group relative bg-white p-8 rounded-2xl flex flex-col items-center justify-center cursor-pointer border hover:border-blue-500 transition-all"
//               >

//                 {/* GLOW EFFECT */}
//                 <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition bg-gradient-to-r from-blue-500/10 to-purple-500/10 blur-xl" />

//                 {/* LOGO */}
//                 <img
//                   src={brand.img}
//                   alt={brand.name}
//                   className="h-20 object-contain relative z-10 transition duration-300 group-hover:scale-110"
//                 />

//                 {/* 🔥 BRAND NAME */}
//                 <p className="mt-4 text-base font-semibold text-gray-800 relative z-10">
//                   {brand.name}
//                 </p>

//               </motion.div>
//             ))}

//           </div>
//         )}

//       </div>

//     </div>
//   );
// };

// export default TopBrands;

import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

import "swiper/css";

const TopBrands = ({ brands = [] }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const handleClick = (brand) => {
    navigate(`/product-category?brand=${brand.name}`);
  };

  if (!brands?.length) return null;

  return (
    <div className="max-w-8xl mx-auto px-4 mt-8">

      {/* 🔥 PREMIUM BACKGROUND */}
      <div className="relative rounded-md p-6 md:p-10 bg-gradient-to-br from-blue-50 via-white to-indigo-50 overflow-hidden">

        {/* Glow Background */}
        <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-200 opacity-30 blur-3xl rounded-full"></div>
        <div className="absolute -bottom-20 -right-20 w-72 h-72 bg-indigo-200 opacity-30 blur-3xl rounded-sm"></div>

        {/* HEADER */}
        <div className="flex justify-between items-center mb-10 relative z-10">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-800">
            Top Brands
          </h2>
        </div>

        {/* 📱 MOBILE */}
        {isMobile ? (
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 2000 }}
            loop
            spaceBetween={14}
            slidesPerView={2.2}
          >
            {brands.map((brand, i) => (
              <SwiperSlide key={i}>
                <motion.div
                  whileTap={{ scale: 0.9 }}
                  whileHover={{ scale: 1.05 }}
                  onClick={() => handleClick(brand)}
                  className="relative bg-white/70 backdrop-blur-xl border border-white/40 rounded-2xl p-5 flex flex-col items-center justify-center shadow-lg cursor-pointer"
                >
                  {/* Glow */}
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-400/10 to-purple-400/10 opacity-0 group-hover:opacity-100 blur-xl"></div>

                  <img
                    src={brand.img}
                    alt={brand.name}
                    className="h-14 object-contain z-10"
                  />

                  <p className="mt-3 text-xs font-semibold text-gray-700 z-10">
                    {brand.name}
                  </p>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (

          /* 💻 DESKTOP PREMIUM GRID */
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 relative z-10">

            {brands.map((brand, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
                whileHover={{
                  y: -12,
                  scale: 1.05
                }}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleClick(brand)}
                className="group relative cursor-pointer"
              >

                {/* 🔥 CARD */}
                <div className="relative bg-white/70 backdrop-blur-xl border border-white/40 rounded-2xl p-6 flex flex-col items-center justify-center shadow-md hover:shadow-2xl transition-all">

                  {/* 🔥 GRADIENT BORDER */}
                  <div className="absolute inset-0 rounded-2xl border border-transparent group-hover:border-blue-400/40"></div>

                  {/* 🔥 GLOW */}
                  <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition bg-gradient-to-r from-blue-400/10 to-purple-400/10 blur-xl"></div>

                  {/* LOGO */}
                  <img
                    src={brand.img}
                    alt={brand.name}
                    className="h-16 object-contain transition duration-300 group-hover:scale-110 z-10"
                  />

                  {/* NAME */}
                  <p className="mt-4 text-sm font-semibold text-gray-800 z-10">
                    {brand.name}
                  </p>

                </div>

              </motion.div>
            ))}

          </div>
        )}

      </div>

    </div>
  );
};

export default TopBrands;